(function () {
    "use strict";
    angular.module("skillBuilderSaaS")
        .controller("DownloadsPreviewCtrl", ["$scope", downloadsPreviewCtrl]);
    function downloadsPreviewCtrl($scope) {
        var vm = this;
        vm.data = {
            files: $scope.$parent.vm.assignment.specificInfo.files
        };
        vm.downloadableMsg = vm.data.files.length > 0 ? "learningItem.learnerAccess.downloadableFile.downloadAllToComplete" : "learningItem.learnerAccess.downloadableFile.notFound";
    }
}());
